(function () {
  var DESKTOP_MIN = 577;

  function getItems(slider) {
    return Array.from(slider.children).filter(function (node) {
      return node.classList && node.classList.contains('content-item');
    });
  }

  function getVisibleCount(slider) {
    var items = getItems(slider);
    if (!items.length) return 1;
    var parent = slider.parentElement;
    if (!parent) return 1;
    var itemWidth = items[0].offsetWidth;
    if (!itemWidth) return 1;
    return Math.max(1, Math.floor(parent.offsetWidth / itemWidth));
  }

  function getMaxPage(slider) {
    var items = getItems(slider);
    var visible = getVisibleCount(slider);
    return Math.max(0, Math.ceil(items.length / visible) - 1);
  }

  function goToPage(slider, page) {
    var items = getItems(slider);
    if (!items.length) return;

    var visible = getVisibleCount(slider);
    var maxPage = getMaxPage(slider);
    page = Math.max(0, Math.min(page, maxPage));

    var index = Math.min(page * visible, Math.max(0, items.length - visible));
    var child = items[index];
    if (!child) return;

    var parentRect = slider.getBoundingClientRect();
    var childRect = child.getBoundingClientRect();
    var val = Math.round(childRect.left - parentRect.left) * -1;

    slider.style.transform = 'translate3d(' + val + 'px, 0px, 0px)';
    slider.setAttribute('data-page', String(page));
    slider.classList.remove('justify-content-center-js');
  }

  function bindSection(section) {
    if (section.querySelector('.bnexo-marquee-nav')) return;

    var slider = section.querySelector('slider-component.slider-desktop');
    var nav = section.querySelector('.slider-buttons-desktop');
    var prev = nav && nav.querySelector('.slider-btn-desk-prev');
    var next = nav && nav.querySelector('.slider-btn-desk-next');

    if (!slider || !prev || !next || section.dataset.bnexoSliderFix === 'true') return;
    section.dataset.bnexoSliderFix = 'true';

    if (!slider.hasAttribute('data-page')) {
      slider.setAttribute('data-page', '0');
    }

    function refresh() {
      if (window.innerWidth < DESKTOP_MIN) return;
      var maxPage = getMaxPage(slider);
      if (maxPage > 0 && nav) {
        nav.classList.remove('hide', 'slider-not-init');
      }
      goToPage(slider, Number(slider.getAttribute('data-page') || 0));
    }

    function onPrev(event) {
      if (window.innerWidth < DESKTOP_MIN) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      goToPage(slider, Number(slider.getAttribute('data-page') || 0) - 1);
    }

    function onNext(event) {
      if (window.innerWidth < DESKTOP_MIN) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      goToPage(slider, Number(slider.getAttribute('data-page') || 0) + 1);
    }

    prev.addEventListener('click', onPrev, true);
    next.addEventListener('click', onNext, true);
    window.addEventListener('resize', refresh, { passive: true });

    refresh();
    window.setTimeout(refresh, 200);
    window.setTimeout(refresh, 900);
  }

  function init() {
    document
      .querySelectorAll('[data-section-name="featured-collection"]')
      .forEach(function (section) {
        delete section.dataset.bnexoSliderFix;
        bindSection(section);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('bnexo:product-pools-updated', init);
})();
